<template>
  <div class="page-card rights-page">
    <!-- 用户头部蓝色横幅 -->
    <div class="user-banner">
      <div class="banner-left">
        <a-upload
          name="avatar"
          :show-upload-list="false"
          :before-upload="beforeAvatarUpload"
        >
          <div class="avatar-box">
            <img v-if="avatarUrl" :src="avatarUrl" class="avatar-img" />
            <div v-else class="avatar-empty">{{ displayName?.slice(0,1) }}</div>
          </div>
        </a-upload>
        <span class="nick-name">{{ displayName }}</span>
        <a-tag style="color:  #165DFF; background: #FFFFFF;border-radius: 8px;">{{ isVip ? '企业版' : '个人版' }}</a-tag>
      </div>
      <div class="banner-right">
        <span v-if="isVip" class="svip-text"><img src="@/assets/perasonal/icon-wg.png" class="svip-icon" /> VIP：有效期至{{ expireTime }}</span>
      </div>
    </div>

    <div class="rights-title">我的权益</div>
    <!-- 权益网格卡片 -->
    <div class="rights-grid">
      <div v-for="item in rightsList" :key="item.id" class="right-card">
        <div class="card-icon">
          <div class="icon-bg" >
            <img :src="item.icon" style="width:76px;height:80px;" />
          </div>
        </div>
        <div style="width: calc(100% - 90px);">
            <div class="card-name">{{ item.benefitTypeName }}</div>
            <div class="card-desc">
            <span v-if="item.unlimit">{{item.totalCount}}</span>
            <span v-else>已使用{{ item.usedCount }}次，剩余{{ item.remainingCount }}次</span>
            </div>
            <div class="progress-bar">
            <div class="progress-inner" :style="{ width: item.unlimit ? '100%' : `${(item.usedCount/(item.totalCount || 1))*100}%`, background: item.color }"></div>
            </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { getUserBenefit } from '../../api/personal/benefit'
const emit = defineEmits(['save-avatar', 'update:expireTime'])

const rightsList = ref([])
const expireTime = ref('')
const userInfo = ref({})
const isVip = ref(localStorage.getItem('isVip') === 'true')
console.log('localStorage',localStorage.getItem('isVip') === 'true')

// 从 localStorage 重新加载用户信息
const loadUserFromStorage = () => {
  try {
    const userStr = localStorage.getItem('user')
    const userData = JSON.parse(userStr || '{}')
    userInfo.value = userData
    if (!expireTime.value) {
      expireTime.value = userData.expireTime || userData.svipDate || ''
    }
  } catch (e) {
    console.error('获取用户信息失败:', e)
  }
}

onMounted(async () => {
  try {
    const res = await getUserBenefit()
    const rawList = res?.data || []
    // 为每条数据插入 icon 字段（icon1 ~ icon12 循环）
    rightsList.value = rawList.map((item, index) => {
      const num = (index % 12) + 1
      // 统一使用蓝色
      return {
        ...item,
        icon: require(`@/assets/perasonal/icon${num}.png`),
        unlimit: false,
        color: item.color || '#165DFF',
      }
    })
    expireTime.value = localStorage.getItem('userExpireTime') || ''
    // expireTime.value = res?.data?.expireTime || ''

    // 同步到 localStorage，供 kevinHome 等组件使用
    // const expireMatch = expireTime.value.match(/\d{4}\/\d{2}\/\d{2}/)
    // if (expireMatch) {
    //   localStorage.setItem('userExpireTime', expireMatch[0])
    // }
  } catch (err) {
    console.error('获取用户权益失败', err)
    // 降级：从 localStorage 读取
    expireTime.value = localStorage.getItem('userExpireTime') || ''
  }

  // 从 localStorage 获取用户头像等信息
  loadUserFromStorage()

  // 监听 InfoPage 保存后触发的更新事件
  window.addEventListener('user-updated', loadUserFromStorage)
})

onUnmounted(() => {
  window.removeEventListener('user-updated', loadUserFromStorage)
})

// 头像
const avatarUrl = computed(() => {
  const file = userInfo.value.headImgFile
  return (file && typeof file === 'string') ? file.trim() : ''
})
const displayName = computed(() => userInfo.value.nickName || userInfo.value.name || '')

// 头像上传拦截
const beforeAvatarUpload = (file) => {
  emit('save-avatar', file)
  return false
}
</script>

<style scoped lang="less">
.page-card {
  background: #fff;
  border-radius: 12px;
  padding: 28px;
}
.user-banner {
  background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%);
  border-radius: 12px;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  .banner-left {
    display: flex;
    align-items: center;
    gap: 12px;
    .avatar-box {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      overflow: hidden;
      background: #fff;
      .avatar-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .avatar-empty {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        color: #1677ff;
      }
    }
    .nick-name {
      font-size: 20px;
      color: #fff;
      font-weight: 500;
    }
  }
  .banner-right {
    .svip-text {
     font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 16px;
      display: flex;
      align-items: center;
      gap: 6px;
      .svip-icon {
        width: 28px;
        height: 28px;
      }
    }
  }
}
.rights-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 16px;
}
.rights-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
.right-card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  .card-icon {
    margin-bottom: 10px;
    margin-right: 24px;
    
    .icon-bg {
      width: 80px;
      height: 80px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
    //   color: #1677ff;
    }
  }
  .card-name {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    margin-bottom: 18px;
  }
  .card-desc {
    font-size: 13px;
    color: #6b7280;
    margin-bottom: 18px;
  }
  .progress-bar {
    width: 100%;
    height: 4px;
    background: #e5e7eb;
    border-radius: 2px;
    overflow: hidden;
    .progress-inner {
      height: 100%;
      border-radius: 2px;
    }
  }
}
</style>